import type { ReactNode } from 'react';
import styles from '@/styles/components/ManageTable/style.scss';

export interface ManageColumn {
  label: string;
  align?: 'right';
}

interface ManageTableProps {
  columns: ManageColumn[];
  loading: boolean;
  /** Shown when there are no rows and nothing is being added. */
  emptyText: string;
  isEmpty: boolean;
  /** Rows (<tr>), including the add row while it is open. */
  children: ReactNode;
}

/** The list on a Manage page: column headers, rows, and an actions column on the right. */
export function ManageTable({ columns, loading, emptyText, isEmpty, children }: ManageTableProps) {
  if (loading) return <p className={styles.muted}>Loading…</p>;

  return (
    <div className={styles.frame}>
      <table className={styles.table}>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.label} className={c.align === 'right' ? styles.right : undefined}>
                {c.label}
              </th>
            ))}
            <th className={styles.actionsHead}>
              <span className={styles.srOnly}>Actions</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {children}
          {isEmpty && (
            <tr>
              <td colSpan={columns.length + 1} className={styles.muted}>
                {emptyText}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
